import { useMutation, useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getHowToUseSection, addHowToUseSection, updateHowToUseSection } from 'api/auth.api';

export const useGetHowToUseSection = () => {
  return useQuery({
    queryKey: ['howToUseSection'],
    queryFn: getHowToUseSection,
  });
};

export const useAddHowToUseSection = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addHowToUseSection,
    onSuccess: (res) => {
      toast({
        title: 'Content Added',
        description: res?.data?.message || 'Added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
      onSuccess?.(res);
    },
    onError: (error) => {
      toast({
        title: 'Failed to add content',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};

export const useUpdateHowToUseSection = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateHowToUseSection,
    onSuccess: (res) => {
      toast({
        title: 'Content Updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
      onSuccess?.(res);
    },
    onError: (error) => {
      toast({
        title: 'Failed to update content',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
